import type { JSX } from 'react';

/**
 * Реестр мини-флагов (icon_handoff_spec §J · 14 флагов, 22×15).
 * 13 стран `vouchers.ts` (ключ = country id) + `gb` для LocaleSwitcher.
 *
 * ВАЖНО: цвета флагов — ЛИТЕРАЛЬНЫЕ (национальная геральдика), НЕ палитра-vars:
 * флаг не должен перекрашиваться темой. Упрощённая геральдика, приглушённые
 * тона под курс. Обёртка `<FlagIcon>` добавляет скругление 3.5 + тонкую ink-рамку.
 */
const FLAGS: Record<string, JSX.Element> = {
  ru: (
    <>
      <rect width="22" height="5" fill="#FFFDF6" />
      <rect y="5" width="22" height="5" fill="#3D6B9E" />
      <rect y="10" width="22" height="5" fill="#B73A1E" />
    </>
  ),
  gb: (
    <>
      <rect width="22" height="15" fill="#3D6B9E" />
      <path d="M0 0 L22 15 M22 0 L0 15" stroke="#FFFDF6" strokeWidth="3.4" />
      <path d="M0 0 L22 15 M22 0 L0 15" stroke="#B73A1E" strokeWidth="1.4" />
      <path d="M11 0 V15 M0 7.5 H22" stroke="#FFFDF6" strokeWidth="4.6" />
      <path d="M11 0 V15 M0 7.5 H22" stroke="#B73A1E" strokeWidth="2.4" />
    </>
  ),
  tr: (
    <>
      <rect width="22" height="15" fill="#B73A1E" />
      <circle cx="9" cy="7.5" r="3.4" fill="#FFFDF6" />
      <circle cx="10.1" cy="7.5" r="2.7" fill="#B73A1E" />
      <path d="M13.6 7.5 l2.2 .7 -1.4 -1.8 v2.2 l1.4 -1.8 Z" fill="#FFFDF6" />
    </>
  ),
  ua: (
    <>
      <rect width="22" height="7.5" fill="#3D6B9E" />
      <rect y="7.5" width="22" height="7.5" fill="#D8A317" />
    </>
  ),
  kz: (
    <>
      <rect width="22" height="15" fill="#2E8AA0" />
      <circle cx="11" cy="7" r="2.6" fill="#D8A317" />
      <path d="M11 2.6 V4 M11 10 V11.4 M6.6 7 H8 M14 7 H15.4 M7.9 3.9 L8.9 4.9 M13.1 9.1 L14.1 10.1 M14.1 3.9 L13.1 4.9 M8.9 9.1 L7.9 10.1" stroke="#D8A317" strokeWidth="1" />
    </>
  ),
  ge: (
    <>
      <rect width="22" height="15" fill="#FFFDF6" />
      <path d="M11 0 V15 M0 7.5 H22" stroke="#B73A1E" strokeWidth="2.6" />
      <path d="M4.5 3 V5 M3.5 4 H5.5 M17.5 3 V5 M16.5 4 H18.5 M4.5 10 V12 M3.5 11 H5.5 M17.5 10 V12 M16.5 11 H18.5" stroke="#B73A1E" strokeWidth="1.1" />
    </>
  ),
  am: (
    <>
      <rect width="22" height="5" fill="#B73A1E" />
      <rect y="5" width="22" height="5" fill="#3D6B9E" />
      <rect y="10" width="22" height="5" fill="#E08A3C" />
    </>
  ),
  az: (
    <>
      <rect width="22" height="5" fill="#2E8AA0" />
      <rect y="5" width="22" height="5" fill="#B73A1E" />
      <rect y="10" width="22" height="5" fill="#4F8F6B" />
      <circle cx="10.4" cy="7.5" r="1.7" fill="#FFFDF6" />
      <circle cx="11" cy="7.5" r="1.35" fill="#B73A1E" />
      <path d="M13.2 7.5 l1.3 .4 -.8 -1.1 v1.4 l.8 -1.1 Z" fill="#FFFDF6" />
    </>
  ),
  by: (
    <>
      <rect width="22" height="10" fill="#B73A1E" />
      <rect y="10" width="22" height="5" fill="#4F8F6B" />
      <rect width="3" height="15" fill="#FFFDF6" />
      <path d="M1.5 1.5 L2.4 3 L1.5 4.5 L0.6 3 Z M1.5 6 L2.4 7.5 L1.5 9 L0.6 7.5 Z M1.5 10.5 L2.4 12 L1.5 13.5 L0.6 12 Z" fill="#B73A1E" />
    </>
  ),
  md: (
    <>
      <rect width="7.3" height="15" fill="#3D6B9E" />
      <rect x="7.3" width="7.4" height="15" fill="#D8A317" />
      <rect x="14.7" width="7.3" height="15" fill="#B73A1E" />
      <circle cx="11" cy="7.5" r="1.9" fill="none" stroke="#8A5A2B" strokeWidth="1.1" />
    </>
  ),
  uz: (
    <>
      <rect width="22" height="5" fill="#2E8AA0" />
      <rect y="5" width="22" height="5" fill="#FFFDF6" />
      <rect y="10" width="22" height="5" fill="#4F8F6B" />
      <rect y="4.6" width="22" height="0.9" fill="#B73A1E" />
      <rect y="9.5" width="22" height="0.9" fill="#B73A1E" />
      <circle cx="4" cy="2.5" r="1.5" fill="#FFFDF6" />
      <circle cx="4.6" cy="2.5" r="1.2" fill="#2E8AA0" />
    </>
  ),
  kg: (
    <>
      <rect width="22" height="15" fill="#B73A1E" />
      <circle cx="11" cy="7.5" r="3.2" fill="#D8A317" />
      <path d="M11 4.3 V10.7 M7.8 7.5 H14.2 M8.7 5.2 L13.3 9.8 M13.3 5.2 L8.7 9.8" stroke="#B73A1E" strokeWidth="0.8" />
      <circle cx="11" cy="7.5" r="1.6" fill="#D8A317" />
    </>
  ),
  pl: (
    <>
      <rect width="22" height="7.5" fill="#FFFDF6" />
      <rect y="7.5" width="22" height="7.5" fill="#B73A1E" />
    </>
  ),
  de: (
    <>
      <rect width="22" height="5" fill="#1F2629" />
      <rect y="5" width="22" height="5" fill="#B73A1E" />
      <rect y="10" width="22" height="5" fill="#D8A317" />
    </>
  ),
};

/** Есть ли в реестре флаг под этот код страны/локали. */
export function hasFlagIcon(code?: string): boolean {
  return !!code && code in FLAGS;
}

/**
 * Мини-флаг по коду страны (id ваучера) или локали (`gb` для en).
 * Возвращает null, если кода нет — вызывающий код рендерит эмодзи-флаг.
 * Скругление 3.5 (clip) + тонкая ink-рамка сверху.
 */
export function FlagIcon({ code, size = 22 }: { code: string; size?: number }) {
  const body = FLAGS[code];
  if (!body) return null;
  const h = Math.round((size * 15) / 22);
  const clipId = `flag-clip-${code}`;
  return (
    <svg
      viewBox="0 0 22 15"
      width={size}
      height={h}
      aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <defs>
        <clipPath id={clipId}>
          <rect width="22" height="15" rx="3.5" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>{body}</g>
      <rect x="0.6" y="0.6" width="20.8" height="13.8" rx="3.1" fill="none" stroke="#1F2629" strokeWidth="1.1" opacity="0.4" />
    </svg>
  );
}
